import React from 'react'
import { Form, Formik } from 'formik'
import Modal from '../../Modal/Modal'
import Input from '../../FormComponents/Input'
import { findExactTag, findSimilarTags } from '../../../utils/tagSimilarity'

export default function TagNameModal({ isOpen, onClose, onSubmit, tags, tag = null }) {
  const otherTags = tags.filter(candidate => candidate.id !== tag?.id)

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Header>
        <span className="font-bold text-lg dark:text-white">{tag ? 'Rename tag' : 'New tag'}</span>
      </Modal.Header>
      <Formik initialValues={{ name: tag?.name || '', confirm_similar: false }} onSubmit={onSubmit}>
        {({ handleChange, handleBlur, values, setFieldValue, isSubmitting }) => {
          const trimmed = values.name.trim()
          const exactMatch = trimmed ? findExactTag(trimmed, otherTags) : null
          const similar = trimmed && !exactMatch ? findSimilarTags(trimmed, otherTags) : []
          const unchanged = tag && trimmed === tag.name
          const canSubmit = trimmed && !exactMatch && !unchanged && !isSubmitting && (!similar.length || values.confirm_similar)

          return (
            <Form>
              <Modal.Body>
                <div className="w-[440px] flex flex-col gap-1">
                  <label className="text-sm font-semibold text-rb-black dark:text-white">Tag name</label>
                  <Input
                    autoFocus
                    topMargin="mt-0"
                    inputPaddingClass="px-3"
                    placeholder="e.g. Fitness"
                    name="name"
                    onChange={event => {
                      handleChange(event)
                      setFieldValue('confirm_similar', false)
                    }}
                    onBlur={handleBlur}
                    value={values.name}
                  />
                  {tag && (
                    <p className="text-xs text-rb-lighter-grey dark:text-gray-400 mt-1">Renaming updates the tag on all {tag.creators_count} creators that use it.</p>
                  )}
                  {exactMatch && (
                    <p className="text-sm mt-2 text-red-600 dark:text-red-400">A tag named <span className="font-semibold">{exactMatch.name}</span> already exists.</p>
                  )}
                  {similar.length > 0 && (
                    <div className="mt-3 rounded-lg border-1 border-amber-300 bg-amber-50 dark:bg-amber-500/10 dark:border-amber-500/40 p-3">
                      <p className="text-sm text-amber-800 dark:text-amber-300">Similar tags already exist: <span className="font-semibold">{similar.map(candidate => candidate.name).join(', ')}</span></p>
                      <label className="flex items-center gap-2 mt-2 text-sm text-gray-700 dark:text-gray-300 cursor-pointer">
                        <input type="checkbox" checked={values.confirm_similar} onChange={event => setFieldValue('confirm_similar', event.target.checked)} />
                        Use "{trimmed}" anyway
                      </label>
                    </div>
                  )}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div className="w-full flex justify-between items-center">
                  <Modal.DissmissButton className="rb-btn-cancel px-4 py-2 text-sm font-semibold rounded-lg">
                    Cancel
                  </Modal.DissmissButton>
                  <button
                    type="submit"
                    disabled={!canSubmit}
                    className="px-4 py-2 text-sm font-semibold text-white bg-rb-green rounded-lg dark:text-rb-dark-mode disabled:opacity-50"
                  >
                    {isSubmitting ? 'Saving...' : (tag ? 'Save' : 'Create')}
                  </button>
                </div>
              </Modal.Footer>
            </Form>
          )
        }}
      </Formik>
    </Modal>
  )
}
